export default __webpack_public_path__ + "static/media/horde.19af755c.png";